var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("NotificationBar"),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-start justify-content-md-between align-items-center flex-column flex-md-row",
          },
          [
            _c("h1", { staticClass: "mr-auto" }, [_vm._v("Customers")]),
            _c(
              "div",
              {
                staticClass:
                  "mb-3 d-flex justify-content-start align-items-center",
              },
              [
                _c(
                  "b-button-group",
                  { staticClass: "mr-2" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-light intro-customer-new",
                        attrs: { to: "/customers/create" },
                      },
                      [_vm._v("New Customer")]
                    ),
                    _c(
                      "b-dropdown",
                      {
                        staticClass: "intro-customer-import",
                        attrs: { right: "", variant: "light" },
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          { on: { click: _vm.showImport } },
                          [_vm._v("Import CSV")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-button-group",
                  { staticClass: "mr-2" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-light intro-customer-new",
                        attrs: { to: "/customers/companies/create" },
                      },
                      [_vm._v("New Company")]
                    ),
                    _c(
                      "b-dropdown",
                      {
                        staticClass: "intro-customer-import",
                        attrs: { right: "", variant: "light" },
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          { on: { click: _vm.showImportCompany } },
                          [_vm._v("Import CSV")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "router-link",
                  {
                    staticClass:
                      "btn btn-light ml-2 my-2 intro-customer-new-presentation",
                    attrs: { to: "/customers/presentations/create" },
                  },
                  [_vm._v("New Presentation")]
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "ul",
          { staticClass: "nav nav-tabs nav-tabs-underline mb-4" },
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "li",
              {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.hover",
                    value: !_vm.showUpgradePlanIcon(tab) && {
                      content: _vm.toolTip,
                      html: true,
                    },
                    expression:
                      "\n          !showUpgradePlanIcon(tab) && {\n            content: toolTip,\n            html: true\n          }\n        ",
                    modifiers: { hover: true },
                  },
                ],
                key: tab.tab,
                staticClass: "nav-item",
                class: tab.class,
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "nav-link text-nowrap",
                    class: {
                      active:
                        tab.link == _vm.currentTab ||
                        (tab.subTabs &&
                          tab.subTabs.some((st) => st.link === _vm.currentTab)),
                    },
                    attrs: { to: tab.link },
                  },
                  [
                    tab.icon
                      ? _c("i", { staticClass: "mr-2 d-none", class: tab.icon })
                      : _vm._e(),
                    _c(
                      "span",
                      { class: !_vm.showUpgradePlanIcon(tab) && "text-muted" },
                      [_vm._v(_vm._s(tab.name))]
                    ),
                    !_vm.showUpgradePlanIcon(tab)
                      ? _c("i", {
                          staticClass:
                            "fas fa-circle fa-xs text-primary position-absolute ml-1",
                        })
                      : _vm._e(),
                    tab.badge
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge badge-pill badge-primary ml-2 d-inline-block",
                          },
                          [_vm._v(_vm._s(tab.badge))]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
        _vm.subTabs
          ? _c(
              "ul",
              { staticClass: "nav nav-tabs nav-tabs-underline mb-4" },
              _vm._l(_vm.subTabs, function (tab) {
                return _c(
                  "li",
                  { key: tab.tab, staticClass: "nav-item", class: tab.class },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "nav-link text-nowrap",
                        class: { active: tab.link == _vm.currentTab },
                        attrs: { to: tab.link },
                      },
                      [
                        tab.icon
                          ? _c("i", {
                              staticClass: "mr-2 d-none",
                              class: tab.icon,
                            })
                          : _vm._e(),
                        _c("span", {}, [_vm._v(_vm._s(tab.name))]),
                        tab.badge
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "badge badge-pill badge-primary ml-2 d-inline-block",
                              },
                              [_vm._v(_vm._s(tab.badge))]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
        _c("router-view"),
        _c(
          "b-modal",
          {
            ref: "customerImport",
            attrs: {
              title: "Import Customers",
              scrollable: "",
              "hide-footer": "",
              "modal-class": "modal right fade",
              "dialog-class":
                "modal-dialog modal-dialog-slideout modal-dialog-slideout-right modal-dialog-slideout-lg",
              "content-class": "no-max-height",
            },
          },
          [
            _c("CustomerImportCSV", {
              on: { submit: _vm.submitImport, cancel: _vm.cancel },
            }),
          ],
          1
        ),
        _c(
          "b-modal",
          {
            ref: "companyImport",
            attrs: {
              title: "Import Companies",
              scrollable: "",
              "hide-footer": "",
              "modal-class": "modal right fade",
              "dialog-class":
                "modal-dialog modal-dialog-slideout modal-dialog-slideout-right modal-dialog-slideout-lg",
              "content-class": "no-max-height",
            },
          },
          [
            _c("CompanyImportCSV", {
              on: {
                submit: _vm.submitCompanyImport,
                cancel: _vm.cancelImportCompany,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }